module.exports = __webpack_public_path__ + "static/media/naver-login.ce672208.png";